import { Button, Card, Image, Modal, Space, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BannerService from "../../../../service/BannerService";
import AddBanner from "./AddBanner";
import EditBanner from "./EditBanner";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { API_IMG_BANNER } from "../../../../configs/AppConfig";

const { confirm } = Modal;

const Banner = () => {
  const [openAdd, setOpenAdd] = useState({
    open: false,
    bannerId: "",
  });

  const [loading, setLoading] = useState(false);

  const [openEdit, setOpenEdit] = useState({
    open: false,
    bannerId: "",
  });
  const [Banner, setBanner] = useState<any>([]);
  const [newBannerId, setNewBannerId] = useState("");

  const showDrawerAdd = async () => {
    setOpenAdd({
      open: true,
      bannerId: "",
    });
  };

  const showDrawerEdit = (record: any) => {
    setOpenEdit({ open: true, bannerId: record?._id });
  };

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      const result = await BannerService.fetchFilter(1);

      setBanner({
        data: result?.data?.banners,
        total: result?.data?.total,
      });
      setLoading(false);
    };
    fetchOrders();
  }, []);

  const columns = [
    // {
    //   title: "品名",
    //   dataIndex: "key",
    //   key: "key",
    // },
    {
      title: "图片kz",
      dataIndex: "img_kk",
      key: "img_kk",
      width: "20%",

      render: (text: string, record: any) => (
        <>
          <Image width={100} src={API_IMG_BANNER + record?.img_kk?.img} />
        </>
      ),
    },
    {
      title: "图片ru",
      dataIndex: "img_ru",
      key: "img_ru",
      width: "20%",
      render: (text: string, record: any) => (
        <>
          <Image width={100} src={API_IMG_BANNER + record?.img_ru?.img} />
        </>
      ),
    },
    {
      title: "图片cn",
      dataIndex: "img_zh",
      key: "img_zh",
      width: "20%",
      render: (text: string, record: any) => (
        <>
          <Image width={100} src={API_IMG_BANNER + record?.img_zh?.img} />
        </>
      ),
    },

    {
      title: "更多",
      key: "action",

      render: (text: string, record: any) => (
        <>
          <Space size="middle">
            <Button
              danger
              type="primary"
              onClick={() => {
                deleteBannerConfirm(record?._id);
              }}
            >
              删除
            </Button>
          </Space>
          <Space size="middle">
            <Button
              type="primary"
              onClick={() => {
                showDrawerEdit(record);
              }}
            >
              修改
            </Button>
          </Space>
        </>
      ),
    },
  ];

  const pageChangeHandle = async (page: number, pageSize: number) => {
    setLoading(true);
    const res = await BannerService.fetchFilter(page);
    setBanner({
      data: res.data.banners,
      total: res.data.total,
    });
    setLoading(false);
  };

  const deleteBanner = async (id: string) => {
    await BannerService.delete(id);
    window.location.reload();
  };

  const deleteBannerConfirm = (id: string) => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      title: "确认删除？",
      okText: "确认",
      cancelText: "取消",
      onOk() {
        deleteBanner(id);
      },
    });
  };

  return (
    <Card>
      <Button
        onClick={showDrawerAdd}
        style={{
          marginTop: 20,
          marginBottom: 20,
          marginLeft: 20,
          backgroundColor: "green",
        }}
        type="primary"
      >
        添加
      </Button>
      <Table
        loading={loading}
        dataSource={Banner.data}
        columns={columns}
        rowKey="_id"
        pagination={{
          pageSize: 12,
          total: Banner.total,
          onChange: pageChangeHandle,
        }}
      />
      {openAdd && <AddBanner openData={openAdd} setOpenData={setOpenAdd} />}
      {openEdit.open && (
        <EditBanner openData={openEdit} setOpenData={setOpenEdit} />
      )}
    </Card>
  );
};

export default Banner;
